<template>
  <div>
    <div class="book-part">
      <div class="hotle-ext-box">
        <a-card :bordered="false" size="small">
          <div slot="title" class="title-box">
            <label class="plate-title">
              <strong>Hotel Ext. (1)</strong>
              <span class="spacing">-</span>
              <span :class="hotelExtshow ? 'spacing switch-btn link-btn active-hotel': 'spacing switch-btn link-btn'" @click="hotelExtshow = true">Pre</span>
              <span :class="hotelExtshow ? 'spacing switch-btn link-btn': 'spacing switch-btn link-btn active-hotel'" @click="hotelExtshow = false">Post</span>
            </label>
          </div>
          <div v-show="hotelExtshow">
            <book-hoter-pre></book-hoter-pre> 
          </div><!-- Hoter Pre -->
          <div v-show="!hotelExtshow">
            <book-hoter-post></book-hoter-post>
          </div>
           <!-- Hoter Post -->
        </a-card>
      </div>
      <book-optional></book-optional> <!-- Optional -->
      <book-others></book-others> <!-- Others -->
      <book-concession></book-concession> <!-- Concession -->
    </div>
    <div class="book-part">
      <a-card :bordered="false">
        <book-grand-total></book-grand-total> <!-- Grand Total -->
      </a-card>
    </div>
    <div class="book-part">
      <a-card :bordered="false">
        <book-payment></book-payment> <!-- Payment -->
      </a-card>
    </div>
    <div class="book-part">
      <a-card :bordered="false">
        <book-btn></book-btn> <!-- Btn -->
      </a-card>
    </div>
  </div>
</template>

<script>
import BookHoterPre from '../charges/hotel/BookHoterExtPre'
import BookHoterPost from '../charges/hotel/BookHoterExtPost'
import BookOptional from '../charges/optional/BookOptional'
import BookOthers from '../charges/others/BookOthers'
import BookConcession from '../charges/concession/BookConcession'
import BookGrandTotal from '../charges/grandTotal/BookGrandTotal'
import BookPayment from '../charges/payment/BookPayment'
import BookBtn from '../charges/btn/BookBtn'

export default {
  name: 'AdditionalCharge',
  components: {
    BookHoterPre,
    BookHoterPost,
    BookOptional,
    BookOthers,
    BookConcession,
    BookGrandTotal,
    BookPayment,
    BookBtn
  },
  props: {
  },
  data () {
    return {
      hotelExtshow: true
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
// 酒店
.hotle-ext-box{
  .title-box{
    strong{
      padding-right: 2px;
    }
    .spacing{
      padding: 0 3px;
      display: inline-block;
    }
    .switch-btn{
      font-weight: normal;
    }
    .switch-btn.active-hotel{
      color: red;
    }
  }
  /deep/.pre-box{
    color: #000;
    span{
      margin-right: 5px;
    }
  }
}
</style>